import React from 'react';
import { Typography, Box } from '@mui/material';
import { colors, fonts } from '../../../constants';

/**
 * FormFieldLabel Component
 * Reusable field label with optional required indicator
 * 
 * @param {string} label - Label text
 * @param {boolean} required - Whether field is required
 */
const FormFieldLabel = ({ label, required = false }) => (
  <Typography
    variant="body2"
    component="label"
    sx={{
      fontSize: fonts.fontSizeMd,
      fontWeight: fonts.weightSemiBold,
      color: colors.textPrimary,
      mb: '6px',
      display: 'block',
      lineHeight: 1.4,
      letterSpacing: '0.01em',
    }}
  >
    {label}
    {required && (
      <Box component="span" sx={{ color: colors.error, ml: '4px' }}>
        *
      </Box>
    )}
  </Typography>
);

export default FormFieldLabel;
